module.exports = __webpack_public_path__ + "img/icon-payment-sms.abd84d2b.png";